

export default function FormText({text, style}) {

    return (
        <div className="form-group">
            <p style={style}>{text}</p>
        </div>
    );
}